import { Component, OnDestroy } from '@angular/core';
import { SedsModalService } from "experian-design-system";
import { takeUntil } from 'rxjs';
import { Utils } from '../../../../utils/utils';
import { VirtualTourService } from '../../services/virtual-tour.service';

@Component({
    selector: 'pl-modal-tour',
    templateUrl: './modal-tour.component.html',
    styleUrls: [
        './modal-tour.component.scss',
        '../../../../../styles/theme/modal.scss',
    ],
    standalone: false,
})
export class ModalTourComponent implements OnDestroy {
  constructor(
    private readonly _dialog: SedsModalService,
    private readonly _virtualTourService: VirtualTourService
  ) {}

  startTour() {
    this._virtualTourService.isOnTour.next(true);
    this._dialog.close();
  }

  close() {
    this._virtualTourService
    .flagTourAsDone()
    .pipe(takeUntil(Utils.componentDestroyed(this)))
    .subscribe();
    this._virtualTourService.isOnTour.next(false);
    this._dialog.close();
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnDestroy(): void {} // NOSONAR
}
